import { render, staticRenderFns } from "./CotacoesMarketplaceHeader.vue?vue&type=template&id=53d47399"
import script from "./CotacoesMarketplaceHeader.vue?vue&type=script&lang=js"
export * from "./CotacoesMarketplaceHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports